import { render, staticRenderFns } from "./compAccessConfiguration.vue?vue&type=template&id=733fc7f4&scoped=true"
import script from "./compAccessConfiguration.vue?vue&type=script&lang=js"
export * from "./compAccessConfiguration.vue?vue&type=script&lang=js"
import style0 from "./compAccessConfiguration.vue?vue&type=style&index=0&id=733fc7f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733fc7f4",
  null
  
)

export default component.exports